goog.declareModuleId('yext.m4.confcode.adminconsole.MissingResourcesModal');
import {SmallDialog} from '/ui/components/modal/dialog';
import {yext} from '/ui/lib/msg';

/**
 * @fileoverview The dialog prompt for missing resources.
 *
 * @author Cheng Peng (cpeng@yext.com)
 */


/**
 * @param {{
 *   nextAction: function(),
 * }} props
 * @return {React.ReactNode}
 */
export function MissingResourcesModal(props) {
  const {
    nextAction,
  } = props;

  const [showDialog, setShowDialog] = React.useState(true);

  // When prop refs are changed, it implies that the modal has been invoked
  // again with a new set of props. In this case refresh the states.
  React.useEffect(() => {
    setShowDialog(true);
  }, [props]);

  const onContinue = () => {
    setShowDialog(false);
    nextAction();
  };

  const buttons = {
    primary: {
      type: 'active',
      text: yext.msg('Continue'),
      tid: 'sl-continue-missing-resources-button',
      callback: onContinue,
    },
    cancel: {
      type: 'cancel',
      text: yext.msg('Cancel'),
    },
  };

  return <SmallDialog
    title={yext.msg('Resources missing from Admin Console')}
    show={showDialog}
    onHideDialog={() => setShowDialog(false)}
    callToAction={buttons}
  >
    <p>{yext.msg('Not all resources from this account have been loaded. ' +
      'We recommend using Yext’s Command Line Interface to do this action ' +
      'instead.')}</p>
    <p>{yext.msg('Are you sure you want to continue with missing ' +
      'resources?')}</p>
  </SmallDialog>;
}
